import ImpersonationBanner from "components/ImpersonationBanner"
import { InformationReturn } from "../../models/auth"
import Footer from "../Footer"
import Header from "../Header"
export default function WebsiteRoute({auth, route}: {auth: InformationReturn, route: React.ReactElement}) {
    return (
        <>
            <Header
                project="STEM Sims"
                isLoggedIn={auth.isLoggedIn}
                isStudent={auth.isStudent}
                isAdmin={auth.isAdmin}
                isStaff={auth.isStaff}
                trackingEnabled={auth.trackingEnabled}
                hasStemSimsAccess={auth.hasStemSimsAccess}
                hasCurriculumAccess={auth.hasCurriculumAccess}
                scienceBlocks={auth.scienceBlocks}
                />
            {route}
            {auth.impersonationMode && auth.permissions.includes("EDITING") && <ImpersonationBanner />}
            <Footer />
        </>
    )
}
